import { IMAGE_URL } from '@/utils/constants';

export interface RemoteImageProps {
    className?: string;
    fileName: string;
}

export const testId = 'remote-image';

export function RemoteImage({
    className,
    fileName,
}: RemoteImageProps): JSX.Element {
    return <img
        data-testid={testId}
        className={className} src={`${IMAGE_URL}/${fileName}`} />;
}
